import {
  useStripe,
  useElements,
  PaymentElement
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { addCard, getCards, processPayment } from "../../apis/apis";
import Button from "../common/Button";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { clearCart } from "../../actions/cartActions";
import { Link, useNavigate } from "react-router-dom";
import { palette } from "../../styled/colors";
import { media } from "styled-bootstrap-grid";
import { Flexed, Spacer } from "../../styled/shared";
import CardDetailsTable from "./CardDetailsTable";
import CardRow from "./CardRow";
import LocationSearch from "../common/LocationSearch";
import { getAddress } from "../utils";

const StripeCardLayout = (data) => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);
  const [message, setMessage] = useState("");
  const cart: any = useSelector<any>((state: any) => state.cart);
  const [cards, setSavedCards] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [cartTotal, setTotal] = useState(0);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [deliveryMethod, setDeliveryMethod] = useState("delivery"); // Default to delivery
  const [isInstructionsOpen, setIsInstructionsOpen] = useState(false);
  const [deliveryInstructions, setDeliveryInstructions] = useState("");
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  let _navigate = useNavigate();
  const [markets, setProductMarkets] = useState<any>(null);
  const [productAddresses, setProductAddresses] = useState<any[]>([]);
  const [productPickupDays, setProductPickupDays] = useState<any[]>([]);
  const [productPickupStartTime, setProductPickupStartTime] = useState("");
  const [productPickupEndTime, setProductPickupEndTime] = useState("");
  const [location, setLocation] = useState("");
  useEffect(() => {
    if (data.sellersAndProducts && data.sellersAndProducts.length === 0) {
      // _navigate("/products");
      return;
    }

    if (cart?.products) {
      setTotal(
        cart.products.reduce((result, item) => {
          return (
            result +
            item.quantity * item.discountPrice +
            Number(item.delivery_fee) +
            Number(item.service_fee)
          );
        }, 0) +
          (localStorage.getItem("tipAmount")
            ? Number(localStorage.getItem("tipAmount"))
            : 0)
      );

      const fetchAddresses = async () => {
        const addresses = await Promise.all(
          cart.products.map(async (item) => ({
            address: await getAddress(item.pickup_lat, item.pickup_long)
          }))
        );
        setProductAddresses(addresses);
      };

      const fetchMarkets = async () => {
        const markets = await Promise.all(
          cart.products.map(async (item) => ({
            is_farmer_market: item.is_farmer_market,
            id: item.id
          }))
        );
        setProductMarkets(markets);
      };

      fetchAddresses();
      fetchMarkets();
      setProductPickupDays(
        cart.products.map((item) => ({
          pickupDays: item.pickup_days
        }))
      );
      setProductPickupStartTime(
        cart.products.map((item) => item.pickup_start_time)
      );

      setProductPickupEndTime(
        cart.products.map((item) => item.pickup_end_time)
      );
    }

    getSavedCards();
  }, [cart?.products, data.sellersAndProducts]);

  const formatTimeToAMPM = (time: string | string[]): string => {
    if (!time) return "";

    // Handle case when time is an array
    const timeString = Array.isArray(time) ? time[0] : time;

    if (!timeString) return "";

    try {
      // Split the time string to get hours
      const [hours, minutes] = timeString.split(":").map(Number);

      // Determine if it's AM or PM
      const period = hours >= 12 ? "PM" : "AM";

      // Convert to 12-hour format
      const displayHours = hours % 12 || 12;

      // Return formatted time
      return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
    } catch (error) {
      console.error("Error formatting time:", error);
      return "";
    }
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setIsProcessing(true);

    elements.submit();
    const result = await stripe.createPaymentMethod({
      elements
    });

    if (result.error) {
      setMessage(result.error.message as string);
    } else {
      const res: any = await addCard(result?.paymentMethod?.id);

      if (res.success) {
        setMessage(res.message);

        if (data.isPlaceOrderPage) {
          getSavedCards();
        } else {
          data.handleChooseDefaultCardClick();
        }
      } else {
        setMessage(res?.message);
        // setMessage(res?.message.raw.message);
      }

      // if (
      //   Array.isArray(data.sellersAndProducts) &&
      //   data.sellersAndProducts.length > 0
      // ) {
      //   const total: number = cart?.products?.reduce((result, item) => {
      //     return result + item.quantity * item.discountPrice;
      //   }, 0);
      //   const paymentResponse: any = await processPayment(
      //     data.sellersAndProducts,
      //     "debitOrCreditCard",
      //     total,
      //     result?.paymentMethod?.id
      //   );
      //   if (paymentResponse.success) {
      //     MySwal.fire({
      //       customClass: {
      //         container: "my-custom-swal",
      //       },
      //       showCloseButton: true,
      //       denyButtonText: paymentResponse.message,
      //       imageUrl: "/images/ThankYouGreen.png",
      //     }).then(() => {
      //       dispatch(clearCart("0"));
      //       _navigate("/products");
      //     });
      //   } else {
      //     setMessage(paymentResponse.message);
      //   }
      // }
    }
    setIsProcessing(false);
    setIsAccordionOpen(false);
  };

  const getSavedCards = async () => {
    setLoading(true);
    const cards: any = await getCards();
    if (cards.success) {
      setSavedCards(cards.data as string[]);
    }
    setLoading(false);
  };

  const payNow = async (paymentMethodId) => {
    setLoading(true);
    if (
      Array.isArray(data.sellersAndProducts) &&
      data.sellersAndProducts.length > 0
    ) {
      const total: number = cart?.products?.reduce((result, item) => {
        return (
          result +
          item.quantity * item.discountPrice +
          Number(item.delivery_fee) +
          Number(item.service_fee)
        );
      }, 0);

      const tip_amount = localStorage.getItem("tipAmount")
        ? Number(localStorage.getItem("tipAmount"))
        : 0;
      const netTotal = total + tip_amount;
      const paymentResponse: any = await processPayment(
        0,
        0,
        tip_amount,
        data.sellersAndProducts,
        "debitOrCreditCard",
        netTotal,
        paymentMethodId,
        "product"
      );
      if (paymentResponse.success) {
        MySwal.fire({
          customClass: {
            container: "my-custom-swal"
          },
          showCloseButton: true,
          denyButtonText: paymentResponse.message,
          imageUrl: "/images/ThankYouGreen.png"
        }).then(() => {
          dispatch(clearCart("0"));
          localStorage.removeItem("tipAmount");
          localStorage.removeItem("deliveryCharges");
          localStorage.removeItem("serviceCharges");
          _navigate("/products");
        });
      } else {
        setMessage(paymentResponse.error);
      }
    }
    setLoading(false);
  };
  const handleDeliveryMethodChange = (event) => {
    // Always set to the clicked checkbox's value regardless of current state
    // This ensures only one option is selected at a time (radio-like behavior)
    const newMethod = event.target.value;
    setDeliveryMethod(newMethod);
  };

  return (
    <>
      <Wrapper>
        {data.isPlaceOrderPage && (
          <>
            <Flexed direction="row" style={{ justifyContent: "space-between" }}>
              <CheckoutHeader>Checkout</CheckoutHeader>
              <ContinueShoppingLink to="/products">
                Continue shopping
              </ContinueShoppingLink>
            </Flexed>
            <Flexed direction="row" style={{ justifyContent: "space-between" }}>
              <DeliveryOptions>
                <OptionLabel
                  className={deliveryMethod === "pickup" ? "active" : ""}
                >
                  <input
                    type="checkbox"
                    id="pickup"
                    name="deliveryMethod"
                    value="pickup"
                    checked={deliveryMethod === "pickup"}
                    onChange={() => {
                      handleDeliveryMethodChange({
                        target: { value: "pickup" }
                      });
                      setIsInstructionsOpen(false);
                    }}
                  />
                  <span>Pickup</span>
                  {deliveryMethod === "pickup" && (
                    <CheckmarkIcon>✓</CheckmarkIcon>
                  )}
                </OptionLabel>
                <OptionLabel
                  className={deliveryMethod === "delivery" ? "active" : ""}
                >
                  <input
                    type="checkbox"
                    id="delivery"
                    name="deliveryMethod"
                    value="delivery"
                    checked={deliveryMethod === "delivery"}
                    onChange={() => {
                      handleDeliveryMethodChange({
                        target: { value: "delivery" }
                      });
                      setIsInstructionsOpen(false);
                    }}
                  />
                  <span>Delivery</span>
                  {deliveryMethod === "delivery" && (
                    <CheckmarkIcon>✓</CheckmarkIcon>
                  )}
                </OptionLabel>
              </DeliveryOptions>
              <RadiusText>3-mile radius</RadiusText>
            </Flexed>
            {deliveryMethod === "delivery" ? (
              <>
                <LocationSearch
                  location={""}
                  setLocationError={() => {}}
                  setLocation={(value) => setLocation(value)}
                  isProfile={true}
                />

                <InstructionsAccordion>
                  <InstructionsHeader
                    onClick={() => setIsInstructionsOpen(!isInstructionsOpen)}
                  >
                    <span>Enter Apt No. or special instructions</span>
                  </InstructionsHeader>
                  <InstructionsContent isOpen={isInstructionsOpen}>
                    <InstructionsTextarea
                      placeholder="Enter Apt No, or special instructions"
                      value={deliveryInstructions}
                      onChange={(e) => setDeliveryInstructions(e.target.value)}
                    />
                  </InstructionsContent>
                </InstructionsAccordion>
              </>
            ) : (
              <InstructionsAccordion>
                <InstructionsHeader
                  onClick={() => setIsInstructionsOpen(!isInstructionsOpen)}
                >
                  <span>Special instructions</span>
                </InstructionsHeader>
                <InstructionsContent isOpen={isInstructionsOpen}>
                  <PickupInfoContainer>
                    <PickupAddressContainer>
                      {markets.map((item) => {
                        return (
                          <PickupAddress key={item.id}>
                            {item.is_farmer_market && "Farmer Market"}
                          </PickupAddress>
                        );
                      })}
                    </PickupAddressContainer>
                    <PickupAddressContainer>
                      <PickupAddressLabel>Pickup Address:</PickupAddressLabel>
                      {productAddresses.map((item) => {
                        return (
                          <PickupAddress key={item.address}>
                            {item.address}
                          </PickupAddress>
                        );
                      })}
                    </PickupAddressContainer>
                    <PickupDaysContainer>
                      <PickupDaysLabel>Pickup days:</PickupDaysLabel>
                      {productPickupDays.map((item, index) => {
                        return (
                          <PickupDays key={index}>
                            {item.pickupDays.join(", ")}
                          </PickupDays>
                        );
                      })}
                      <PickupHours>
                        Between the hours{" "}
                        {formatTimeToAMPM(productPickupStartTime)}-
                        {formatTimeToAMPM(productPickupEndTime)}
                      </PickupHours>
                    </PickupDaysContainer>
                  </PickupInfoContainer>
                </InstructionsContent>
              </InstructionsAccordion>
            )}
            <Spacer height={2} />
            <Flexed
              direction="row"
              style={{ justifyContent: "space-between", alignItems: "center" }}
            >
              <div>I agree to the total charge of ${cartTotal}</div>
              <ViewOrderLink to="/cart">View Order</ViewOrderLink>
            </Flexed>
            <Flexed>
              {cards.map((card) => {
                if (card.isDefault) {
                  return (
                    <table>
                      <tbody>
                        <CardRow card={card} payNow={payNow} />
                      </tbody>
                    </table>
                  );
                }
                return null;
              })}
            </Flexed>
            <Flexed direction="column" gap="0">
              <Spacer height={0.325} />{" "}
              <AccordionHeader
                onClick={() => setIsAccordionOpen(!isAccordionOpen)}
              >
                <span>{isAccordionOpen ? "Hide Form" : "Add New Card"}</span>
                <AccordionIcon isOpen={isAccordionOpen}>▼</AccordionIcon>
              </AccordionHeader>
              <AccordionContent isOpen={isAccordionOpen}>
                <form onSubmit={handleSubmit}>
                  {loading ? <div>Loading...</div> : <PaymentElement />}
                  <div className={`d-flex gap-2 mt-3`}>
                    <div>
                      <Button
                        disabled={
                          isProcessing || !stripe || !elements || loading
                        }
                        id="submit"
                        label={isProcessing ? "Processing ... " : "Save Card"}
                        type="primary"
                      ></Button>
                      {message && (
                        <div id="payment-message" className="mt-2">
                          {message}
                        </div>
                      )}
                    </div>
                  </div>
                </form>
              </AccordionContent>
              <CardDetailsTable cardDetails={cards} payNow={payNow} />
              <Link to="/settings">Manage your credit cards</Link>
            </Flexed>
          </>
        )}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  background-color: ${palette.white};
  width: 100%;

  flex-direction: column;
  padding: 24px !important;
  align-items: start;
  border-radius: 1rem;
  ${media.lg`align-items: center; padding: 0rem 0.6rem;`}
  ${media.xl`align-items: start;`}
	margin-bottom : 20px !important;
`;

const CheckoutHeader = styled.h2`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
`;

const ContinueShoppingLink = styled(Link)`
  font-size: 14px;
  color: #000;
  margin-bottom: 24px;
  display: inline-block;
`;

const DeliveryOptions = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  justify-content: space-between;
`;

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;

  &.active {
    border-color: ${palette.primary};
    background-color: rgba(0, 128, 0, 0.05);
  }

  input {
    margin-right: 8px;
  }
`;

const CheckmarkIcon = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: ${palette.primary};
  color: ${palette.white};
  border-radius: 3px;
  margin-left: 8px;
  text-align: center;
  line-height: 16px;
  font-size: 11px;
`;

const RadiusText = styled.span`
  font-size: 12px;
  color: #666;
  margin-left: 4px;
`;

const ViewOrderLink = styled(Link)`
  font-size: 14px;
  color: #000;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  font-weight: 500;
  color: #333;

  &:hover {
    background-color: #f9f9f9;
  }
`;

const AccordionIcon = styled.span<{ isOpen: boolean }>`
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0)")};
  transition: transform 0.3s ease;
  font-size: 12px;
`;

const AccordionContent = styled.div<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  padding: 10px 0;
  overflow: hidden;
  transition: all 0.3s ease;
`;

const PickupInfoContainer = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 12px;
  margin-top: 12px;
  background-color: #f9f9f9;
`;

const PickupAddressContainer = styled.div`
  margin-bottom: 10px;
`;

const PickupAddressLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
`;

const PickupAddress = styled.div`
  font-size: 14px;
  color: #333;
`;

const PickupDaysContainer = styled.div``;

const PickupDaysLabel = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
`;

const PickupDays = styled.div`
  font-size: 14px;
  color: #333;
`;

const PickupHours = styled.div`
  font-size: 14px;
  color: #666;
  margin-top: 4px;
`;

const InstructionsAccordion = styled.div`
  margin-top: 16px;
  // border: 1px solid #e0e0e0;
  // border-radius: 4px;
  overflow: hidden;
`;

const InstructionsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 12px 16px;
  // background-color: #f8f9fa;
  cursor: pointer;
  font-weight: 500;
  color: #333;
  font-size: 14px;

  &:hover {
    background-color: #e9ecef;
  }
`;

const InstructionsIcon = styled.span<{ isOpen: boolean }>`
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0)")};
  transition: transform 0.3s ease;
  font-size: 12px;
  color: #666;
`;

const InstructionsContent = styled.div<{ isOpen: boolean }>`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  padding: 16px;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
`;

const InstructionsTextarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: ${palette.primary};
    box-shadow: 0 0 0 2px rgba(0, 128, 0, 0.1);
  }

  &::placeholder {
    color: #999;
  }
`;

export default StripeCardLayout;
